import axios from '../../axios';
import { GET_COMPANY_TIMEZONES } from '../api';

const cachedTimezoneOptions = new Map();
const timezoneRequests = new Map();

export const fetchCompanyTimezones = async (apiClient = axios, endpoint = GET_COMPANY_TIMEZONES) => {
  if (cachedTimezoneOptions.has(endpoint)) return cachedTimezoneOptions.get(endpoint);
  if (timezoneRequests.has(endpoint)) return timezoneRequests.get(endpoint);

  const request = apiClient.get(endpoint)
    .then((response) => {
      const payload = response?.data;
      const options = [
        payload,
        payload?.data,
        payload?.timezones,
        payload?.data?.timezones,
        payload?.data?.data,
      ].find(Array.isArray);
      if (!options) {
        throw new Error('Timezone options were not returned in the expected format.');
      }

      const timezones = options
        .filter((option) => typeof option?.value === 'string' && typeof option?.label === 'string')
        .map(({ value, label }) => ({ value, label }));
      if (!timezones.length) {
        throw new Error('No valid timezone options were returned.');
      }

      cachedTimezoneOptions.set(endpoint, timezones);
      return timezones;
    })
    .catch((error) => {
      timezoneRequests.delete(endpoint);
      throw error;
    });

  timezoneRequests.set(endpoint, request);
  return request;
};

export const includeCurrentTimezone = (options, currentValue) => {
  if (!currentValue || options.some((option) => option.value === currentValue)) return options;
  return [{ value: currentValue, label: `Saved timezone (${currentValue})` }, ...options];
};
